export default __webpack_public_path__ + "static/FiraMono-Bold-742f3b26c42d55b203276905545c7ccd.woff";